const TAGGING = {
	HIGH_VALUE_CART: 'drop_protection_checkout_popup',
};

export default TAGGING;
